import type { AxiosError } from 'axios'
import i18n from 'utils/i18n'
import type { BaseQueryArgs, QueryArgs } from './types'

export type AppError = AxiosError<{
  detail?: {
    message?: string
  }
  message?: string
}>

export type ErrorResponse =
  | {
      error: unknown
    }
  | {
      data: unknown
    }

export const handleError = (
  err: AppError,
  args: QueryArgs,
  _baseQueryArgs: BaseQueryArgs,
): ErrorResponse => {
  if (err.response) {
    if (err.response?.data && err.response?.data?.detail) {
      return {
        error: {
          message: err.response.data.detail.message,
          data: err.response.data,
          errorOverride: args.errorOverride,
          code: err.response.status,
        },
      }
    } else if (err.response.data && err.response.data.message) {
      return {
        error: {
          message: err.response.data.message,
          data: err.response.data,
          errorOverride: args.errorOverride,
          code: err.response.status,
        },
      }
    } else if (err.response.status >= 500) {
      return {
        error: { status: err.response.status, data: err, errorOverride: args.errorOverride },
      }
    } else {
      return {
        error: {
          message: i18n.t('response.message.unknown.error'),
          errorOverride: args.errorOverride,
          code: err.response.status,
        },
      }
    }
  } else if (err.code === 'ECONNABORTED') {
    if (err.message.startsWith('Request aborted ')) {
      return { data: undefined }
    } else {
      return { error: { message: i18n.t('response.message.network.error') } }
    }
  } else if (err.message) {
    const { message } = err
    return { error: { message } }
  } else {
    return { error: { message: i18n.t('response.message.unknown.error') } }
  }
}
